import { SecureStorageService } from './../Services/secure-storage.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { localStorageKeys, applicationPaths } from '../Models/configurations';

@Injectable({
  providedIn: 'root'
})
export class RouteAuthenticationGuard  {
  // canActivate(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return true;
  // }

  constructor(
    private router: Router,
    private secureStorageService: SecureStorageService,
  ) {
  }

  canActivate() {
    if (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)) {
      return true;
    } else {
      this.router.navigateByUrl('/' + applicationPaths.unauthorize)
      return false;
    }
  }

}
